export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const ONE_MINUTE_IN_MILLISECONDS = 60 * ONE_SECOND_IN_MILLISECONDS;
export const NOTIFICATION_BEFORE_IDLE_MINUTES = 5;
export const INTERVAL_THROTTLE_IN_MILLISECONDS = 500;
